module.exports = __webpack_public_path__ + "img/cabinet_off.a354d5b8.svg";